import { FormInput } from "components/ProjectNonSpecificComponents/Elements/FormElements/FormInput"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { observer } from "mobx-react"
import React, { useRef } from "react"
import { useTranslation } from "react-i18next"
import PreferencesSmallButton from "../../atoms/Buttons/PreferencesSmallButton"
import Checkbox from "../../atoms/Checkbox"

const SubmitTextConfiguration = observer(() => {
	const formStore = useFormStore()
	const { t } = useTranslation()
	const { settingsLanguage } = formStore
	const inputRef = useRef<HTMLInputElement & HTMLTextAreaElement>(null)
	const { submitText } = formStore.settingsData.additionalInfo
	// ! TECHNICAL DEBT: 3184, replace this with dynamic key ([parsedkey])
	let isEN = settingsLanguage == "en"
	const onInsertButtonClick = (string: string) => {
		if (!inputRef.current) return
		let position = inputRef.current?.selectionStart
		if (isEN) {
			formStore.mergeUserFormWelcomeTextData({
				submitText: {
					...submitText,
					notificationTextEN:
						submitText?.notificationTextEN.substring(0, position) +
						string +
						submitText?.notificationTextEN.substring(position),
				},
			})
		} else {
			formStore.mergeUserFormWelcomeTextData({
				submitText: {
					...submitText,
					notificationTextLV:
						submitText?.notificationTextLV.substring(0, position) +
						string +
						submitText?.notificationTextLV.substring(position),
				},
			})
		}

		inputRef.current?.focus()
		inputRef.current?.setSelectionRange(position, position)
	}

	return (
		<div className="px-4 py-2">
			<div className="flex flex-row whitespace-nowrap w-full pb-2 justify-between">
				<p className="text-sm pr-1 pt-1">{t("rawText.submit-text")}</p>
				<div className="flex flex-row">
					<p className="text-sm pr-1 pt-1">{t("rawText.submit-text-enable")}</p>
					<Checkbox
						checked={submitText?.isEnabled}
						onCheck={(checked) => {
							formStore.mergeUserFormWelcomeTextData({
								submitText: {
									...submitText,
									isEnabled: checked,
								},
							})
						}}
					/>
				</div>
			</div>
			<HyperDiv margin=".5rem">
				<PreferencesSmallButton
					style={{ height: "auto" }}
					onClick={() => onInsertButtonClick("{{documentKey}}")}
					children={t("rawText.documentKey")}
				/>
			</HyperDiv>

			<FormInput
				ref={inputRef}
				multiline
				wide
				value={isEN ? submitText?.notificationTextEN : submitText?.notificationTextLV ?? ""}
				onValueChange={(text) =>
					formStore.mergeUserFormWelcomeTextData(
						isEN
							? {
									submitText: {
										...submitText,
										notificationTextEN: text,
									},
							  }
							: {
									submitText: {
										...submitText,
										notificationTextLV: text,
									},
							  }
					)
				}
			/>
		</div>
	)
})

export default SubmitTextConfiguration
